/**
 * tb_service_item 마스터 enum.
 *
 * 운영 DB의 tb_service_item 9개 row를 모두 미리 등록.
 * 코드 어디에서도 raw 숫자(2, 3 등) 사용 금지.
 *
 * 구조:
 *   - depth=0 (그룹): SDK, CLOUD_FUNCTION, CRYPTO_API
 *   - depth=1 (항목, parent=SDK): SDK_AGENT, POLICY_SERVER, INITIAL_INSTALL_SERVICE,
 *     MAINTENANCE, ON_SITE_INSPECTION, DECRYPT_SUPPORT
 */
export const ServiceItemNumber = Object.freeze({
    // depth=0 그룹
    SDK: 1,
    CLOUD_FUNCTION: 8,
    CRYPTO_API: 9,
    // depth=1 항목
    SDK_AGENT: 2,
    POLICY_SERVER: 3,
    INITIAL_INSTALL_SERVICE: 4,
    MAINTENANCE: 5,
    ON_SITE_INSPECTION: 6,
    DECRYPT_SUPPORT: 7,
});
